import React from 'react'
import { montaTypes } from 'src/constants/montaType'
import { formatDate } from 'src/utils'
import { DiagnosisBadge } from '../../components/DiagnosisBadge'
import { PregnancyDiagnosisDto } from 'src/dto/pregnancy-diagnosis.dto'
export const useBreedingListTableHeader = () => {
  const tableHeader = [
    {
      property: 'nomeVaca',
      name: 'NOME VACA',
      textAlign: 'center',
      format: (value: string) => value || '-'
    },
    {
      property: 'numero',
      name: 'NÚMERO',
      textAlign: 'center',
      format: (value: string) => value || '-'
    },
    {
      property: 'tipoReproducao',
      name: 'REPRODUÇÃO',
      format: (value: string) => (value ? montaTypes[value]?.value ?? '-' : '-'),
      textAlign: 'center'
    },
    {
      property: 'dataInicial',
      name: 'DATA COBERTURA',
      format: (value: string) => formatDate(value, false) || '-',
      textAlign: 'center'
    },

    {
      property: 'status',
      name: 'STATUS',
      size: 280,
      compoment: (value: PregnancyDiagnosisDto) => (
        <DiagnosisBadge key={value.id} diagnosis={value.diagnostico} item={value} />
      )
    }
  ]

  return {
    tableHeader
  }
}
